import { Colaboracao, FocoNoCliente, Inovacao, Resolutividade, Lideranca } from 'components/icons';
import { format } from 'date-fns';
import { UserAvatar } from 'components/user-avatar';
import { useAuth } from 'context/AuthContext';
import { useEffect, useState } from 'react';
import { getRewardFeed } from 'services/dashboard.service';
import Box from 'components/ui/box';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Button from 'components/ui/button';
import { convertEmojis } from 'utils/helpers';
import Humanograma from 'components/Humanograma';

const iconSize = 30;

const Behaviors: any = {
  colaboracao: (
    <div className="w-[30px]">
      <Colaboracao size={iconSize} />
    </div>
  ),
  inovacao: (
    <div className="w-[30px]">
      <Inovacao size={iconSize} />
    </div>
  ),
  foco: (
    <div className="w-[30px]">
      <FocoNoCliente size={iconSize} />
    </div>
  ),
  resolutividade: (
    <div className="w-[30px]">
      <Resolutividade size={iconSize} />
    </div>
  ),
  lideranca: (
    <div className="w-[30px]">
      <Lideranca size={iconSize} />
    </div>
  ),
};

const BehaviorLabel: any = {
  colaboracao: 'Colaboração',
  inovacao: 'Inovação',
  foco: 'Foco no Cliente',
  resolutividade: 'Proatividade',
  lideranca: 'Liderança Engajadora',
};

interface Props {
  filter?: any;
}

export default function RecognitionFeed(data: Props) {
  const { user, currentCycle } = useAuth();
  const [list, setList] = useState<any[]>([]);
  const [loadingList, setLoadingList] = useState(true);
  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    async function loadData() {
      if (!page) setLoadingList(true);
      const rangeItem = page ? page * 5 : 0;

      if (page) setLoad(true);

      const data = await getRewardFeed(currentCycle?.date_start, currentCycle?.date_finish, rangeItem, 20);
      setList(prev => (page ? [...prev, ...data.result] : data.result));
      setTotalPage(data.range.pages);
      setLoadingList(false);
      setLoad(false);
    }

    if (!!user && !!currentCycle) {
      loadData();
    }
  }, [currentCycle, user, page]);

  return (
    <>
      <Box className="relative bg-oxford-blue border-electric-blue lg:p-6 flex flex-col justify-center items-center border-opacity-100 bg-opacity-100">
        {loadingList && (
          <div className="space-y-2 w-full">
            <ArticlePlaceholder />
            <ArticlePlaceholder />
          </div>
        )}

        {!loadingList && (
          <div className="space-y-2 w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {!!list?.length &&
                list?.map((item: any) => (
                  <div className="bg-maastricht-blue-3 rounded-xl text-gray-300 space-y-2 py-6 px-6 lg:px-8" key={item?._id}>
                    <div className="flex flex-col lg:flex-col items-start lg:items-start mb-5">
                      <div className="flex-1 flex flex-col-reverse lg:flex-row items-start space-x-2 leading-tight w-full">
                        <div className="flex flex-1 w-full items-start">
                          <div className="mr-2 w-11">
                            <UserAvatar data={item.target_avatar} />
                          </div>
                          <div className="flex-1 w-full block">
                            <Humanograma
                              data={{
                                nome: item.target_name,
                                funcao: item.target_funcao,
                                diretoria: item.target_diretoria,
                                _id: item.target,
                              }}
                            >
                              <div className="flex items-center">
                                <p className="flex flex-row items-center text-sm lg:text-base text-alice-blue font-semibold hover:cursor-pointer hover:underline">
                                  {item.target_nome_guerra || item.target_name.split(' ')[0]}
                                </p>
                                <>
                                  <span className="hidden lg:block whitespace-nowrap font-thin text-sm lg:text-base text-alice-blue ml-1">
                                    recebeu:
                                  </span>
                                  <span className="lg:hidden font-thin text-sm lg:text-base text-alice-blue ml-1">recebeu:</span>
                                </>
                              </div>
                            </Humanograma>

                            <div className="block 2xl:flex flex-col 2xl:flex-row 2xl:items-center w-full space-y-2 2xl:space-y-0 2xl:space-x-2 mt-1">
                              <div
                                className={`inline-flex flex-row items-center space-x-2 px-3 py-1 text-yellow bg-oxford-blue rounded-full`}
                                tabIndex={0}
                              >
                                {Behaviors[item.behavior]} <span className="text-xs">{BehaviorLabel[item.behavior]}</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="text-gray-400 text-xs leading-none flex justify-end my-3 lg:my-0">
                          <span>{format(new Date(item.time), 'dd MMM yyyy | HH:mm')}</span>
                        </div>
                      </div>

                      {/* <div className="flex flex-col lg:flex-row flex-wrap lg:items-center w-full space-y-3 lg:space-y-0 lg:space-x-2 lg:ml-14 mt-4 lg:-mt-4">
                      <div className="w-1/2 lg:w-auto pr-1 lg:pr-0">
                        <div className="flex flex-row items-center space-x-2 px-2 text-yellow py-1 bg-oxford-blue rounded-full">
                          {Coins[item.coin]} <span className="text-xs">{CoinLabel[item.coin]}</span>
                        </div>
                      </div>
                      <div className="w-1/2 lg:w-auto lg:pl-0">
                        <div className="flex flex-row items-center space-x-2 px-2 bg-oxford-blue py-1 text-yellow rounded-full">
                          {Behaviors[item.behavior]} <span className="text-xs">{BehaviorLabel[item.behavior]}</span>
                        </div>
                      </div>
                      <div className="w-1/2 flex items-center space-x-2">
                        <div onClick={() => handleDetail(item)} className="cursor-pointer hover:ring-2 ring-white whitespace-nowrap lg:mt-0 flex-1 lg:flex-none flex flex-row items-center space-x-2 px-2 bg-oxford-blue py-1 text-electric-blue rounded-full">
                          <span>total = {item.total} pts</span>{' '}
                        </div>

                        <div>
                          <BiInfoCircle size={20} />
                        </div>
                      </div>
                    </div> */}
                    </div>

                    <hr className="border-prussian-blue" />

                    {!!item.message && (
                      <>
                        <div className="p-2 flex-1 flex-col" tabIndex={0}>
                          <p className="text-electric-blue font-thin">Reconhecimento recebido:</p>
                          <div className="text-alice-blue" dangerouslySetInnerHTML={{ __html: convertEmojis(item.message) }} />
                        </div>
                      </>
                    )}
                  </div>
                ))}

              {!list?.length && (
                <>
                  <p className="text-white text-base text-center font-light leading-none block py-6">
                    Nenhum reconhecimento recebido até o momento.
                  </p>
                </>
              )}
            </div>

            {page + 1 < totalPage && (
              <div className="w-full flex justify-center mt-8">
                <Button disabled={load} className="px-4 py-2 mx-auto" type="button" onClick={() => setPage(page + 1)}>
                  {load ? 'Carregando...' : 'Carregar mais'}
                </Button>
              </div>
            )}
          </div>
        )}
      </Box>
    </>
  );
}
